import React from 'react';
const comparisonRows = [{
  without: 'Seguís resolviendo varias cosas sola',
  with: 'Aplicás más rápido'
}, {
  without: 'Improvisás más recursos',
  with: 'Trabajás con herramientas concretas'
}, {
  without: 'Implementás más lento',
  with: 'Reducís improvisación operativa'
}, {
  without: 'Menos estructura práctica',
  with: 'Mejor percepción profesional'
}, {
  without: 'Caos operativo diario',
  with: 'Más orden real'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-grayLight py-8 px-5" data-id="element-73">
      <div className="max-w-xl mx-auto" data-id="element-74">
        <h3 className="text-xl md:text-2xl font-black mb-8 flex items-center gap-3 justify-center text-[#EEF1F4]" data-id="element-75">
          🧠 LA DIFERENCIA REAL
        </h3>

        <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-76">
          <div className="text-xs font-black text-red-500 uppercase tracking-widest flex items-center justify-center gap-2 bg-red-50 py-2 rounded-lg border border-red-100 text-center px-2" data-id="element-77">
            ❌ Sin sistema completo
          </div>
          <div className="text-xs font-black text-brand-primary uppercase tracking-widest flex items-center justify-center gap-2 bg-brand-primary/5 py-2 rounded-lg border border-brand-primary/10 text-center px-2" data-id="element-78">
            ✅ Con sistema completo
          </div>
        </div>

        <div className="space-y-3" data-id="element-79">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-4 border-b border-slate-100 pb-4 last:border-0" data-id="element-80">
              <p className="text-sm text-slate-400 font-medium leading-relaxed italic" data-id="element-81">
                {row.without}
              </p>
              <p className="text-sm font-bold leading-relaxed text-[#D4B16A]" data-id="element-82">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}